import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
  Tooltip,
  useMediaQuery,
  useTheme
} from '@mui/material'

export interface ResponsiveButtonProps extends Omit<ButtonProps, 'children'> {
  label: string
  icon?: JSX.Element
  breakpoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  IconButtonProps?: IconButtonProps
  ButtonProps?: ButtonProps
}

export default function ResponsiveButton({
  label,
  icon,
  breakpoint = 'sm',
  variant,
  startIcon,
  endIcon,
  IconButtonProps,
  ButtonProps,
  ...props
}: ResponsiveButtonProps) {
  /**
   * The theme.
   */
  const theme = useTheme()

  /**
   * Indicates if the viewport is mobile.
   */
  const isMobile = useMediaQuery(theme.breakpoints.down(breakpoint))

  return isMobile ? (
    <Tooltip title={label}>
      <IconButton {...{ ...props, ...IconButtonProps }}>{icon}</IconButton>
    </Tooltip>
  ) : (
    <Button
      variant={variant}
      startIcon={startIcon}
      endIcon={endIcon}
      {...{ ...props, ...ButtonProps }}
    >
      {label}
    </Button>
  )
}
